module.exports = __webpack_public_path__ + "static/media/paragraph.30cd1a12.svg";